import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfigService } from './app-config.service';
import { EmailFamilyTreeNode } from '@models/ui/email-family-tree-node.model';

@Injectable({
  providedIn: 'root'
})
export class EmailFamilyService {

  constructor(private http: HttpClient, private appConfigService: AppConfigService) { }

  get(emailFamilyId: string): Observable<EmailFamilyTreeNode> {
    return this.http.get<EmailFamilyTreeNode>(`${this.appConfigService.getConfig().webApi}/api2/EmailFamilies/${emailFamilyId}/docs`);
  }
}
